import { useState, useEffect } from 'react';
// Use the data imports as provided
import N4DataJa from '../../../assets/n4/n4Data.ja.json';
// import N4DataEn from '../../../assets/N4/N4Data.en.json';
// import N4DataMm from '../../../assets/N4/N4Data.mm.json';
import AdUnit from '../../../components/ads/AdUnit'; 

import MojiGoiQ1 from './N4MojiGoiQ1';
import MojiGoiQ2 from './N4MojiGoiQ2';
import MojiGoiQ3 from './N4MojiGoiQ3';
import MojiGoiQ4 from './N4MojiGoiQ4';
import MojiGoiQ5 from './N4MojiGoiQ5';

import N4BunpooQ1 from './N4BunpooQ1';
import N4BunpooQ2 from './N4BunpooQ2';
import N4BunpooQ3 from './N4BunpooQ3';
import N4Dokai1 from './N4Dokai1';


const ADS = {
  client: 'ca-pub-2811591266080010',  // <-- replace with your publisher ID
  topSlot: '2331374547',              // <-- replace with your TOP banner slot
  leftSlot: '3859244481',             // <-- LEFT rail slot
  rightSlot: '3034900367',            // <-- RIGHT rail slot
};

const layoutStyles = {
  page: {
    display: 'grid',
    gridTemplateColumns: 'min(960px, 100%)', 
    gap: '12px',
    alignItems: 'start',
    justifyContent: 'center', 
    margin: '0 auto',
  },
  topBar: {
    maxWidth: 960,
    margin: '0 auto 12px auto',
  },
  center: {
    width: '100%',
    background: '#fff',
    padding: '12px', 
    boxSizing: 'border-box',
    margin: '0', 
    maxWidth: 'none', 
  },
  railWrap: {
    position: 'sticky',
    top: 80,
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
  },
  railBox: {
    width: 160,
  },
};

const SECTION_LABELS = {
  ja: {
    kanji_vocab: '文字・語彙',
    grammar_reading: '文法・読解',
    listening: '聴解'
  },
};

const SECTIONS = [
  { key: 'kanji_vocab' },
  { key: 'grammar_reading' },
  { key: 'listening' }
];

const dataMap = {
  ja: N4DataJa,
  // en: N4DataEn,
  // mm: N4DataMm
};

// Helper to check if a question is answered (single value only)
function isAnswered(val) {
  return val !== undefined && val !== null && val !== '';
}

// Renamed from N4 to N4ContentLayout and accepts initialYear
export default function N4ContentLayout({ initialYear }) {
  // Hardcode lang for simplicity since no lang selector was present
  const lang = 'ja'; 
  
  // Initialize year state with the prop
  const [year, setYear] = useState(initialYear); 
  const [section, setSection] = useState('kanji_vocab');
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [showResult, setShowResult] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  
  // NOTE: If the user navigates to another year from the landing page, 
  // the component will re-mount and year will be correctly set by initialYear.
  
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 200);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const years = dataMap[lang].map(entry => entry.year);
  const yearData = dataMap[lang].find(entry => entry.year === year);
  
  // --- (Calculations remain the same) ---
  const kanjiVocabQuestions = [
    ...(yearData?.sections?.moji_goi_q1 || []),
    ...(yearData?.sections?.moji_goi_q2 || []),
    ...(yearData?.sections?.moji_goi_q3 || []),
    ...(yearData?.sections?.moji_goi_q4 || []),
    ...(yearData?.sections?.moji_goi_q5 || []),
  ];

  const grammarReadingQuestions = [
    ...(Array.isArray(yearData?.sections?.bunpoo_q1)
      ? yearData.sections.bunpoo_q1.flat()
      : yearData?.sections?.bunpoo_q1 || []),
    ...(Array.isArray(yearData?.sections?.bunpoo_q2)
      ? yearData.sections.bunpoo_q2.flat()
      : yearData?.sections?.bunpoo_q2 || []),
    ...(Array.isArray(yearData?.sections?.bunpoo_q3)
      ? yearData.sections.bunpoo_q3.flat()
      : yearData?.sections?.bunpoo_q3 || []),
    ...(Array.isArray(yearData?.sections?.dokai_q1)
      ? yearData.sections.dokai_q1.flat()
      : yearData?.sections?.dokai_q1 || [])
  ];

  const questions =
    section === 'kanji_vocab'
      ? kanjiVocabQuestions
      : section === 'grammar_reading'
        ? grammarReadingQuestions
        : yearData?.sections?.[section] || [];

  const totalQuestions =
    section === 'kanji_vocab'
      ? kanjiVocabQuestions.length
      : section === 'grammar_reading'
        ? grammarReadingQuestions.length
        : 0;

  const answeredCount =
    section === 'kanji_vocab'
      ? kanjiVocabQuestions.filter(q => isAnswered(selectedAnswers[q.id])).length
      : section === 'grammar_reading'
        ? grammarReadingQuestions.filter(q => isAnswered(selectedAnswers[q.id])).length
        : 0;

  const correctCount =
    section === 'kanji_vocab'
      ? kanjiVocabQuestions.filter(q => selectedAnswers[q.id] === q.correct).length
      : section === 'grammar_reading'
        ? grammarReadingQuestions.filter(q => selectedAnswers[q.id] === q.correct).length
        : 0;

  const notAnsweredCount = totalQuestions - answeredCount;

  const handleAnswerChange = (questionId, answerIdx) => {
    setSelectedAnswers(prev => ({
      ...prev,
      [questionId]: answerIdx
    }));
  };

  const handleConfirm = () => {
    setShowResult(true);
    setShowDialog(true);
  };

  const handleReset = () => {
    setShowResult(false);
    setSelectedAnswers({});
    setShowDialog(false);
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
  };
  // --- (End of Calculations) ---

  const globalStyles = `
    /* HIDE ADS RAILS ON SMALL SCREENS */
    @media (max-width: 1200px) {
      .ad-rail {
        display: none !important;
      }
    }
    
    /* DESKTOP 3-COLUMN LAYOUT */
    @media (min-width: 984px) { 
      .N4-page-container {
        /* Revert to 3-column on wide screens */
        grid-template-columns: minmax(0, 1fr) min(960px, 100%) minmax(0, 1fr) !important;
      }
    }

    /* FIX CONFIRM BUTTON WIDTH/POSITIONING */
    .fixed-confirm-bar {
      z-index: 1000; 
      max-width: 984px; 
      width: 100%;
      box-sizing: border-box;
      padding: 0 12px;
    }
  `;

  return (
    <div>
      <style dangerouslySetInnerHTML={{ __html: globalStyles }} />
      
      {/* Year Title (Replaces the old dropdown) */}
      <h2 style={{ color: '#1976d2', margin: '0 0 1rem 0' }}>
        JLPT N4: {year}
      </h2>
      
      {/* TOP banner (centered above the container) */}
      <div style={layoutStyles.topBar}>
        <AdUnit
          client={ADS.client}
          slot={ADS.topSlot}
          style={{ display: 'block', textAlign: 'center', minHeight: 90 }}
          format="auto"
          fullWidth
        />
      </div>

      {/* Main Grid Container - Using className for Media Queries */}
      <div className="N4-page-container" style={layoutStyles.page}>
        
        {/* LEFT rail (Column 1 - will be hidden/pushed to the grid edge on mobile) */}
        <div className="ad-rail" style={layoutStyles.railWrap} aria-hidden>
          <div style={layoutStyles.railBox}>
            <AdUnit
              client={ADS.client}
              slot={ADS.leftSlot}
              style={{ display: 'block', minHeight: 600 }}
              format="auto"
            />
          </div>
        </div>

        {/* CENTER content (Column 2) - **ALL main content is here** */}
        <div style={layoutStyles.center}>
          
          {/* Section Selector */}
          <div style={{ marginBottom: '1rem', borderBottom: '2px solid #ccc', display: 'flex', gap: '0.5rem' }}>
            {SECTIONS.map(s => (
              <button
                key={s.key}
                onClick={() => {
                  setSection(s.key);
                  setSelectedAnswers({});
                  setShowResult(false);
                  setShowDialog(false);
                }}
                style={{
                  background: section === s.key ? '#fff' : '#f5f5f5',
                  color: section === s.key ? '#1976d2' : '#333',
                  border: '1px solid #ccc',
                  borderBottom: section === s.key ? '2px solid #fff' : '2px solid #ccc',
                  borderRadius: '8px 8px 0 0',
                  padding: '0.5rem 1.5rem',
                  fontWeight: section === s.key ? 'bold' : 'normal',
                  outline: 'none',
                  cursor: 'pointer',
                  marginBottom: '-2px'
                }}
              >
                {SECTION_LABELS[lang][s.key]}
              </button>
            ))}
          </div>

          {/* N4 Question => Kanji/Vocab */}
          {section === 'kanji_vocab' && (
            <>
              <MojiGoiQ1
                questions={yearData?.sections?.moji_goi_q1 || []}
                selectedAnswers={selectedAnswers}
                showResult={showResult}
                handleAnswerChange={handleAnswerChange}
              />
              <MojiGoiQ2
                questions={yearData?.sections?.moji_goi_q2 || []}
                selectedAnswers={selectedAnswers}
                showResult={showResult}
                handleAnswerChange={handleAnswerChange}
              />
              <MojiGoiQ3
                questions={yearData?.sections?.moji_goi_q3 || []}
                selectedAnswers={selectedAnswers}
                showResult={showResult}
                handleAnswerChange={handleAnswerChange}
              />
              <MojiGoiQ4
                questions={yearData?.sections?.moji_goi_q4 || []}
                selectedAnswers={selectedAnswers}
                showResult={showResult}
                handleAnswerChange={handleAnswerChange}
              />
              <MojiGoiQ5
                questions={yearData?.sections?.moji_goi_q5 || []}
                selectedAnswers={selectedAnswers}
                showResult={showResult}
                handleAnswerChange={handleAnswerChange}
              />
            </>
          )}

          {/* N4 Question => Grammar/Reading */}
          {section === 'grammar_reading' && (
            <>
              <N4BunpooQ1
                questions={yearData?.sections?.bunpoo_q1 || []}
                selectedAnswers={selectedAnswers}
                showResult={showResult}
                handleAnswerChange={handleAnswerChange}
              />

              <N4BunpooQ2
                questions={yearData?.sections?.bunpoo_q2 || []}
                selectedAnswers={selectedAnswers}
                showResult={showResult}
                handleAnswerChange={handleAnswerChange}
              />

              <N4BunpooQ3
                questions={yearData?.sections?.bunpoo_q3 || []}
                selectedAnswers={selectedAnswers}
                showResult={showResult}
                handleAnswerChange={handleAnswerChange}
              />

              <N4Dokai1
                questions={yearData?.sections?.dokai_q1 || []}
                selectedAnswers={selectedAnswers}
                showResult={showResult}
                handleAnswerChange={handleAnswerChange}
              />
            </>
          )}

          {/* N4 Question => Listening */}
          {section === 'listening' && (
            <>
              {/* Render your listening components here */}
            </>
          )}
        </div> {/* END of CENTER content (Column 2) */}

        {/* RIGHT rail (Column 3) */}
        <div className="ad-rail" style={layoutStyles.railWrap} aria-hidden>
          <div style={layoutStyles.railBox}>
            <AdUnit
              client={ADS.client}
              slot={ADS.rightSlot}
              style={{ display: 'block', minHeight: 600 }}
              format="auto"
            />
          </div>
        </div>
      </div>

      {/* Confirm Button (Fixed - Outside the grid) */}
      {
        questions.some(q => q.answers) && (
          <div
            className="fixed-confirm-bar"
            style={{
              position: 'fixed',
              bottom: 24,
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <button
              onClick={handleConfirm}
              style={{
                background: '#1976d2',
                color: '#fff',
                border: 'none',
                padding: '0.7rem 2rem',
                borderRadius: '4px',
                fontSize: '1.2rem',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(25,118,210,0.07)'
              }}
            >
              Confirm
            </button>
            {showResult && (
              <button
                onClick={handleReset}
                style={{
                  marginLeft: '1rem',
                  background: '#eee',
                  color: '#000',
                  border: 'none',
                  padding: '0.7rem 2rem',
                  borderRadius: '4px',
                  fontSize: '1.2rem',
                  cursor: 'pointer'
                }}
              >
                Reset
              </button>
            )}
          </div>
        )
      }

      {/* Result Dialog (Fixed - Outside the grid) */}
      {showDialog && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000 
          }}
        >
          <div
            style={{
              background: '#fff',
              padding: '2rem',
              borderRadius: '8px',
              minWidth: '320px',
              boxShadow: '0 2px 16px rgba(0,0,0,0.2)'
            }}
          >
            <h2>Result Summary</h2>
            <div>Total questions: {totalQuestions}</div>
            <div>Answered: {answeredCount}</div>
            <div>Correct: {correctCount}</div>
            <div>Not answered: {notAnsweredCount}</div>
            <button
              onClick={handleCloseDialog}
              style={{
                marginTop: '1rem',
                background: '#1976d2',
                color: '#fff',
                border: 'none',
                padding: '0.5rem 1.5rem',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Back to Top Button (Fixed - Outside the grid) */}
      {showScrollTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          style={{
            position: 'fixed',
            bottom: 90,
            right: 40,
            zIndex: 9999,
            background: '#1976d2',
            color: '#fff',
            border: 'none',
            borderRadius: '50%',
            width: 48,
            height: 48,
            fontSize: '2rem',
            boxShadow: '0 2px 8px rgba(25,118,210,0.15)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          aria-label="Back to top"
          title="Back to top"
        >
          ↑
        </button>
      )}
    </div>
  );
}